export default "__VITE_ASSET__9d71f782__"